<template>
  <section class="hero" :style="heroStyle">
    <div class="hero-overlay">
      <h1>{{ title }}</h1>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    title: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    heroStyle() {
      return {
        backgroundImage: `url(${this.imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        height: '400px', /* Adjust height as needed */
      };
    },
  },
};
</script>

<style scoped>
.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Adjust overlay color and opacity */
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-overlay h1 {
  color: #fff;
  font-size: 3em;
  text-align: center;
  margin: 0 20px;
}
</style>